import React, { Component, Suspense } from 'react'
import validator from 'validator';
import Axios from "axios";
import axios from "axios";
import Moment from "react-moment";
import moment from "moment";
import "moment/locale/pt";
import Popup from "../Popup";
import DropdownPais from "../Dropdown/DropdownPais";
import DropdownCAE from "../Dropdown/DropdownCAE";
import DropdownYN from "../Dropdown/DropdownYN";
import logoLong from "../../logoISQ.gif";
import logo from "../../ISQ-Logo.jpg";
import "../Client/ClientUpdate.scss";
import Cookies from "js-cookie";
import Input from 'react-validation/build/input';
import Parser from 'fast-xml-parser';
import { checkVAT, countries } from 'jsvat';
import ReactDOM from 'react-dom'
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next'
import publicIP from 'react-native-public-ip';



const changeLanguage = (event) => {		
	console.log(event.target.value);
	i18n.changeLanguage(event.target.value);
}

function Translate({value}) {
	const { t} = useTranslation();
	return  t(value) 
}

  const email = (value) => {

	console.log("chamouuuu");
	if (!validator.isEmail(value)) {
	  return `${value} is not a valid email.`
	}
  };
   
  
class ExternalData  extends React.Component {
	
	constructor(props)  {

		super(props);
		this.PaisRequired =  [];
		this.state = {
			databaseId : 0,
			id: 0,
			nome: "",
			nome_2: "",
			morada: "",
			morada_2: "",
			cd_post: "",
			localidade: "",
			pais: "",
			nif: "",
			telefone: "",
			fax: "",
			e_mail: "",
			site: "",
			observacoes: "",
			telemovel: "",
			sector_activ: "",
			cod_cert_prm: "",
			grp_economico: "",
			cae: 0,
			mail_contato: "",
			fat_ele: "",
			fin_nome_contato: "",
			fin_tel_contato: "",
			fin_mail_contato: "",
			fin_horario_forn: "",
			submitButton : true, 
			mensagem: "",
			popupShow: false,
			popupTitle: "",
			popupLines: [],
			submetido: false,
			submetidA: null,
			submetidoPor : "",
			lastUpdateBy : "" ,
			viesButton : true, 
			tokenId : window.location.pathname.split("/")[2],
			path : window.location.pathname.split("/")[1],
			showdata : this.displayData,
			CaeRequired : false , 
			padding2 : "",
			padding1 : "",
			value :"en" ,
			sim : "",
			nao : "" , 
			faturaRequired : false, 
			behaviour : null , 
			found : false,
			lojaVirtual: "",
			migrationClient: false
		};

		this.handleChange 		= this.handleChange.bind(this);
		this.handleChangeRadio 	= this.handleChangeRadio.bind(this);
		this.submitClient 		= this.submitClient.bind(this);
		this.sendData 			= this.sendData.bind(this);
		this.viesInteraction 	= this.viesInteraction.bind(this);
		this.changePopupStatus 	= this.changePopupStatus.bind(this);
		this.removeClient 		= this.removeClient.bind(this);
		this.VerificarCancelar 	= this.VerificarCancelar.bind(this);

		if(i18n.language == "en"){
			this.state.sim = "Yes" ;
			this.state.nao = "No";
		}
		else{
			this.state.sim = "Sim" ;
			this.state.nao = "Não";
		}
	
		this.supportedJsvatCountries = [
		"Andorra","Austria","Belgium","Brazil","Bulgaria","Switzerland",
		"Cyprus","Czech Republic","Germany","Denmark","Greece","Spain",
		"Europe","Estonia","Finland","France","United Kingdom","Croatia",
		"Hungary","Ireland","Italy","Latvia","Lithuania","Luxembourg",
		"Malta","Netherlands","Norway","Poland","Portugal","Romania",
		"Russia Federation","Serbia","Slovenia","Slovakia republic","Sweden"
		];
	
		this.countries = new Array();

		Axios.get(`https://${process.env.REACT_APP_API_IP}/api/country`)
		.then(res => {
			res.data.forEach(element => {
			var countryObj = {
				code: element.countryCode,
				name: element.name
			};          
			this.countries.push(countryObj);
			});
		})
		.catch(err => {
			console.log(err);
		});

	}

	VerificarCancelar(){
		this.setState({
			popupShow: true,
			behaviour: this.removeClient ,
			popupTitle: "Atenção" , 
			popupLines: ["Se confirmar, o cliente deixa de estar disponível"],
		  });
	}

	async removeClient() {
		console.log(this.state.databaseId);
		console.log("IDD");

		this.setState({
		  popupShow: true,
		  popupTitle: "A recusar cliente",
		  popupLines: ["Por favor aguarde"]
		});

		let userIP = await publicIP();

		await axios
		  .post(`https://${process.env.REACT_APP_API_IP}/api/clients/state`, {
			id: this.state.databaseId, 
			action: -1 , 
			observation : "Confirmação de recusa de cliente",
			userip: userIP
		  })
		  .then(res => {
			this.setState({
			  popupLines: ["Cliente recusado com sucesso"]
			});
			console.log("Resposta ao recusar:");
			console.log(res);
			setTimeout(function(){  window.location.reload(); }, 1000);
		  
		  })
		  .catch(error => {
			  this.setState({
				popupTitle: "Erro ao recusar",
				popupLines: ["Contacte o departamento responsável"]
			  });
			
			console.log("Erro ao recusar:");
			console.log(error);
		
		  });
	  }


	async submitClient() {

		// NIF (VAT)
		if (!!this.state.nif && this.state.nif != "") {
			// 1 - Country validation (for countries supported by the framework)
			try {
				var selectedCountry = this.countries.find(x => x.code.toLowerCase() == this.state.pais.toLowerCase());
				if (selectedCountry != null && this.supportedJsvatCountries.some(x => x.toLowerCase() == selectedCountry.name.toLowerCase())) {
					var vatCheckResult = checkVAT(this.state.pais + this.state.nif, countries);
					if (!vatCheckResult.isValid) {
						this.setState({
						popupShow: true, 
						popupTitle: "Error" ,
						popupLines: [<Translate value="nifnaocorrespondeaopais"></Translate>]});
						return;
					}
				}
			} catch (error) {
				console.error(error);
			}
		}
	
	
		// CODIGO POSTAL
		if (!!this.state.cd_post && this.state.cd_post != "") {
			// 1 - Country validation
			try {
				const postalCodes = require('postal-codes-js');
				if (postalCodes.validate(this.state.pais, this.state.cd_post) != true) {
				this.setState({
					popupShow: true,
					popupTitle: "Error" ,
					popupLines: [<Translate value="codigopostalnaocorrespondeaopais"></Translate>]});
				return;
				}
			} catch (error) {
				console.error(error);
			}
		
			// 2 - Portuguese code validation
			if (this.state.pais == 'PT') {
				try {
					let res = await Axios({
						url: `https://${process.env.REACT_APP_API_IP}/api/ctt/${this.state.cd_post}`,
						method: 'get'
					});
					if (res.status = 200) {
						let jsonObj = Parser.parse(res.data, {ignoreAttributes:false });
						if (jsonObj.hasOwnProperty('Erro') && !jsonObj.Erro.hasOwnProperty('Result')) {
						this.setState({
							popupShow: true,
							popupTitle: "Error" ,
							popupLines: [<Translate value="codigopostalinvalido"></Translate>]});
						return;
						}
						else {
							var idlo_4digits = "";
							if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade['@_idlo'] != null) {
								idlo_4digits = jsonObj.OK.Localidade['@_idlo'];
							}
							else if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade.length > 1) {
								idlo_4digits = jsonObj.OK.Localidade[0]['@_idlo'];
							}
							else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade['@_idlo'] != null) {
								idlo_4digits = jsonObj.Erro.Localidade['@_idlo'];
							}
							else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade.length > 1) {
								idlo_4digits = jsonObj.Erro.Localidade[0]['@_idlo'];
							}
							idlo_4digits = idlo_4digits.substr(idlo_4digits.length - 4);
							this.state.concelho = idlo_4digits;
						}
					}
				} catch (error) {
				console.error(error);
				}
			}

		}


		if (!validator.isEmail(this.state.e_mail)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" , 
				popupLines: [<Translate value ="emailinvalidocliente" ></Translate>],
			  });
			return 
		}

		if (!validator.isEmail(this.state.fin_mail_contato)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" , 
				popupLines: [<Translate value ="emailinvalidocontatofinanceiro" ></Translate>],
			  });
			return 
		}

		if (this.state.faturaRequired &&  !validator.isEmail(this.state.mail_contato)) {
			this.setState({
				popupShow: true,
				popupTitle: "Error" , 
				popupLines: [<Translate value ="emailinvalidofaturaeletronica" ></Translate>],	
			  });
			return 
		}
   
		let objToSend = this.state;
		delete objToSend.clientsList;
		delete objToSend.buttonOff;
		delete objToSend.popupShow;
		delete objToSend.popupTitle;
		delete objToSend.popupLines;
		delete objToSend.sector_activ;
		console.log(objToSend);
	
	
		this.setState({
		  popupShow: true,
		  popupTitle: <Translate value ="asubmeterdados" ></Translate>,
		  popupLines: [<Translate value ="porfavoraguarde" ></Translate>]
		});
		await Axios
		  .post(`https://${process.env.REACT_APP_API_IP}/api/clients/submit`, objToSend)
		  .then(res => {
			this.setState({
			  popupLines: [<Translate value ="clientesubmetidocomsucesso" ></Translate>],
			 
			});
			window.location.reload();
			
		  })
		  .catch(error => {
		
	
			 if (error.response.status === 200) {
			 
				this.setState({
					popupShow: false,
				  });
			} else {
			  this.setState({
				popupTitle: <Translate value ="erroaoenviar" ></Translate>,
			
			  });
			}
		  
		  });
		  
		
	  }
	
	
	
	handleChange(event) {
		const inputName = event.target.name;

		

		if(inputName == "fat_ele"){
			if(event.target.value == "X"){

				const element =<label><Translate value ="EmailFaturaEletronica" ></Translate><font color ="red">*</font>  </label>
				ReactDOM.render(element, document.getElementById('fatura'));
				this.setState({faturaRequired: true });
			}else{

				const element = <label><Translate value ="EmailFaturaEletronica" ></Translate>  </label>
				ReactDOM.render(element, document.getElementById('fatura'));
				this.setState({faturaRequired: false });
			}
			
		}
		if(inputName == "pais"){
			
		
			if(event.target.value == "PT"){
				const element = <label>Cae<font color ="red">*</font></label>;
				ReactDOM.render(element, document.getElementById('CaeRequired'));
				this.setState({CaeRequired: true });
				
			   
			}else{
				const element = <label>Cae</label>;
				ReactDOM.render(element, document.getElementById('CaeRequired'));
				
				this.setState({CaeRequired: false });
			}
		}
		this.setState({
			buttonOff: false,
			[inputName]: event.target.value
		}, () => {


		
			if(this.ValidateAllInputs()){
	  
		
			  this.setState({
	  
				submitButton : false
			

			  });
			
		   
		   
		   
			}else{
				
			  this.setState({
	  
				submitButton : true ,
				
			  });
	  
	  
			}
		  });
	  
		
		
	}

	ValidateAllInputs() {
		return this.ValidateDadosGerais() &&
				this.ValidateContactoFinanceiro() 
			&& this.ValidateDadosFaturacao();
	}

	changePopupStatus() {
		console.log("change status");
		this.setState({
		  popupShow: !this.state.popupShow,
		  behaviour : null,
		  viesModalState: false
		});
	  }

	ValidateDadosGerais() {
		return !!this.state.nome && !!this.state.morada && !!this.state.localidade
			&& !!this.state.cd_post && !!this.state.pais && !!this.state.e_mail &&
			(!!this.state.telefone || !!this.state.telemovel || !!this.state.fax)
	}

	ValidateContactoFinanceiro() {
		return !!this.state.fin_horario_forn && !!this.state.fin_mail_contato && !!this.state.fin_tel_contato &&
			!!this.state.fin_nome_contato;
	}

	ValidateDadosFaturacao() {
		console.log("FAT_ELE");
		console.log(this.state.fat_ele.length);
		return this.state.fat_ele.length > 0 && ((!this.state.CaeRequired) || (this.state.CaeRequired && !!this.state.cae)) &&
			((!this.state.faturaRequired) || (this.state.faturaRequired && !!this.state.mail_contato));
	}

	sendData() {
		this.setState({ mensagem: "aguardar" });
		if (this.state.pais == 'PT') {
			try {
				let res = Axios({
					url: `https://${process.env.REACT_APP_API_IP}/api/ctt/${this.state.cd_post}`,
					method: 'get'
				});
				if (res.status = 200) {
					let jsonObj = Parser.parse(res.data, { ignoreAttributes: false });
					if (jsonObj.hasOwnProperty('Erro') && !jsonObj.Erro.hasOwnProperty('Result')) { }
					else {
						var idlo_4digits = "";
						if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade['@_idlo'] != null) {
							idlo_4digits = jsonObj.OK.Localidade['@_idlo'];
						}
						else if (jsonObj.hasOwnProperty('OK') && jsonObj.OK.Localidade.length > 1) {
							idlo_4digits = jsonObj.OK.Localidade[0]['@_idlo'];
						}
						else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade['@_idlo'] != null) {
							idlo_4digits = jsonObj.Erro.Localidade['@_idlo'];
						}
						else if (jsonObj.hasOwnProperty('Erro') && jsonObj.Erro.Localidade.length > 1) {
							idlo_4digits = jsonObj.Erro.Localidade[0]['@_idlo'];
						}
						idlo_4digits = idlo_4digits.substr(idlo_4digits.length - 4);
						this.state.concelho = idlo_4digits;
					}
				}
			} catch (error) {
				console.error(error);
			}
		}

		let obj = this.state;
		delete obj.mensagem;

		if (this.state.path == "changeselfdata"){
			obj.lastUpdateBy = "CLIENTE"
		}
		else {
			obj.lastUpdateBy = "ISQ"
		}

		Axios.post(`https://${process.env.REACT_APP_API_IP}/api/clients/changeselfdata`, obj)
			.then(res => {
				this.setState({ mensagem: "dadosguardadoscomsucesso" });
				console.log(res.data);
				this.componentDidMount();
			})
			.catch(err => {
				this.setState({ mensagem: "erroguardardados" });
				console.log(err.response);
			});	
	}

	componentDidMount() {
	moment.locale("pt");

	try {
		Axios.get(`https://${process.env.REACT_APP_API_IP}/api/clients/getselfdata/${this.state.tokenId}`)
			.then(res => {	
				if(res.data.fat_ele == "X"){
					const element =<label><Translate value ="EmailFaturaEletronica" ></Translate><font color ="red">*</font>  </label>
					ReactDOM.render(element, document.getElementById('fatura'));
					this.setState({faturaRequired: true });
				}
				else {
					const element = <label><Translate value ="EmailFaturaEletronica" ></Translate>  </label>
					ReactDOM.render(element, document.getElementById('fatura'));
					this.setState({faturaRequired: false });
				}
				
				if(res.data.pais== "PT"){
					const element = <label>Cae<font color ="red">*</font></label>;
					ReactDOM.render(element, document.getElementById('CaeRequired'));
					this.setState({ CaeRequired: true });
				}
				else {
					const element = <label>Cae</label>;
					ReactDOM.render(element, document.getElementById('CaeRequired'));
					this.setState({CaeRequired: false });
				}

				if (res.data.submetido == true || res.data.aprovado == false) {
					this.setState({ 
						blocked: true ,
						submetido : res.data.submetido,
						submetidA : res.data.submetidA,
						aprovado:  res.data.aprovado , 
						found : true
					});
				}
				else {
					this.setState({
						blocked: false,
						submetido : res.data.submetido,
						databaseId : res.data.databaseID,
						id: res.data.id,
						nome: res.data.nome,
						nome_2: res.data.nome_2,
						morada: res.data.morada,
						morada_2: res.data.morada_2,
						cd_post: res.data.cd_post,
						localidade: res.data.localidade,
						pais: res.data.pais,
						nif: res.data.nif,
						telefone: res.data.telefone,
						fax: res.data.fax,
						e_mail: res.data.e_mail,
						site: res.data.site,
						observacoes: res.data.observacoes,
						telemovel: res.data.telemovel,
						sector_activ: res.data.sector_activ,
						cod_cert_prm: res.data.cod_cert_prm,
						grp_economico: res.data.grp_economico,
						cae: res.data.cae,
						mail_contato: res.data.mail_contato,
						fat_ele: res.data.fat_ele,
						fin_nome_contato: res.data.fin_nome_contato,
						fin_tel_contato: res.data.fin_tel_contato,
						fin_mail_contato: res.data.fin_mail_contato,
						fin_horario_forn: res.data.fin_horario_forn,
						cli_s_ref: res.data.cli_s_ref,
						updateby: res.data.lastUpdateBy,
						updateat: res.data.lastUpdateAt,
						lojaVirtual: res.data.lojaVirtual
					}, () =>
					{
						if (this.ValidateAllInputs()) {
							this.setState({ submitButton: false, found: true });
						}

						if(res.data.lojaVirtual === "X"){
							this.setState({
							  migrationClient: true
							});
						  }else{
							this.setState({
							  migrationClient: false
							});
						  }
					});
				}
			})
			.catch(err => {
			
				this.setState({found: false , blocked : true});
			});

	  }catch(Exception){

		
	  }	
	}
	handleChangeRadio (){

		//this appens moments before language change
       if(i18n.language == "pt"){
	
	
		this.setState({ sim: "Yes" , nao : "No"});

	   }else{
		this.setState({ sim: "Sim" , nao : "Não"});
	   }

	}
	async viesInteraction() {
	
		this.setState({
		  popupShow: true,
		  popupTitle: <Translate value ="avalidarnif" ></Translate>, 
		  popupLines: [<Translate value ="porfavoraguarde" ></Translate>] , 
		 
		});
		await axios
		  .post(
			`https://${process.env.REACT_APP_API_IP}/api/clients/nif/validate`,
			{
			  countryCode: this.state.pais,
			  vatCode: this.state.nif
			}
		  )
		  .then(res => {
			console.log("RES");
			console.log(res);
			if (res.data.valid) {
			  this.setState({
				popupTitle: [<Translate value ="nifvalido" ></Translate>],
				popupLines:[<div><b><Translate value ="Nome" >  </Translate> : </b> {res.data.name }   </div>, 
				<div><b><Translate value ="Morada" >  </Translate> : </b> {res.data.address }   </div> ]
				,
				viesModalState: true
			  });
			} else {
			  this.setState({
			   popupTitle: [<Translate value ="seminformacao" ></Translate>] ,
				popupLines: [<Translate value ="seminformacao2" ></Translate>],
				viesModalState: true
			  });
			}
		  })
		  .catch(err => {
		   
			console.log(err.response);
			this.setState({
			    popupTitle: [<Translate value ="seminformacao" ></Translate>] ,
				popupLines: [<Translate value ="seminformacao2" ></Translate>],
			});
		  });
	  }
	
	render(){

		if(Cookies.get("username") == undefined){
      
			this.state.padding1 = "col-sm-10";
			this.state.padding2 =  "col-1";
		 
		  
		
		}else{
		 
			this.state.padding1 = "col-sm-12";
			this.state.padding2 =  "";
		
		
		}
		const { blocked } = this.state;

		console.log(this.state);
	
		if (blocked) {
			return (
				<>
					<div className="row">
						<img
							style={{
								marginTop: 70,
								width: "100px",
								height: "auto"
							}}
							className="mx-auto"
							src={logo}
							alt="isq logo"
						/>
					</div>

					
					<div style={{ marginTop: 50 }} className="row">
					
						<div className="col-md-4"></div>
					
						<div className="col-md-4">
						<div onChange={changeLanguage} >
      								<input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  />    Português 
    							    <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio} /> English
   						   </div>
							  <br></br>
							<div className="main-card mb-3 card">



                            {!this.state.found  && ( 


									<div className="card-body">
									<h5>Not Found</h5>
									<br />
										<br />

										<br></br>
										<br></br>

										</div>



							)}
							{this.state.aprovado !=  false && this.state.submetido && (
								<div className="card-body">
									<h5><Translate value ="osseusdadosforamsubmetidos" ></Translate></h5>
									<br />
									<br />
									<b><Translate value ="data" ></Translate>:</b>&nbsp;  
							

								  <Moment format="DD-MM-YYYY HH:mm[h]">
								{this.state.submetidA}  
							</Moment> (d-m-y)  
									<br></br>
									<br></br>
								
								</div>)}

								{this.state.aprovado == false && (
								<div className="card-body">
									<h5><Translate value ="pedidoaberturaclientecancelado" ></Translate></h5>
									<br />
									<br />
									<br />
									<br />
								
							

								
									<br></br>
									<br></br>
								
								</div>)}


							</div>
						</div>
						<div className="col-md-4"></div>
					</div>{" "}
				</>
			);
		} else {
			return (
				<React.Fragment>
					   <Popup
          viesModal={this.state.viesModalState}
		  updateStatus={this.changePopupStatus}
		  behaviour = {this.state.behaviour}
		  useViesData={this.useDataFromVies}
          popupShow={this.state.popupShow}
          popupTitle={this.state.popupTitle}
		  popupLines={this.state.popupLines}
		
        ></Popup>
		
					<div className="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header">
						<div className="app-header header-shadow">
							<div className="app-header__logo">
								<img
									style={{ height: 50 }}
									src={logoLong}
									alt="ISQ"
								/>
							</div>
						</div>
						<div class = 'row'>
            <div id='espaco' class={
      this.state.padding2
      }>

            </div>
			<div id='dados' class={
      this.state.padding1
      }>
		  
							<h4
								className="sectionTitle"
								style={{ paddingTop: 60 }}>
							
							</h4>

							<div onChange={changeLanguage}>
      <input type="radio" value="pt" name="language"  onChange ={this.handleChangeRadio}  /> Português
      <input type="radio" value="en" name="language"  onChange ={this.handleChangeRadio}/> English
    </div>
							<div className="pendingRow">
							
								<div className="clientSingleField col4">
								<label><Translate value ="Nif" ></Translate> <font color="red">*</font></label>
							<br />
									<input
										type="text"
										className="form-control"
										value={this.state.nif}
										onChange={this.handleChange}
										name="nif"
										maxLength="20"
										disabled={this.state.migrationClient}
									/>
								</div>

								<div className="clientSingleField col4">
								
								
								<label><Translate value ="Pais" ></Translate><font color="red">*</font></label>
							
									<select
										className="dropcol3"
										className="form-control"
										value={this.state.pais}
										onChange={this.handleChange}
										name="pais"
										disabled={this.state.migrationClient}>
										<DropdownPais />
									</select>
								</div>
								<div className="clientSingleField col4">
            <label>&nbsp;</label>
            <br />
			{!this.state.migrationClient &&
            <button
              onClick={this.viesInteraction}
              className="mb-1 mr-2 btn btn-secondary btn-lg"> 
			  <Translate value ="Validar" ></Translate>
            </button>}
          </div>
							</div>
							<div className="pendingRow">
								<div className="clientSingleField col2">
								<label> <Translate value ="Nome" ></Translate> <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.nome || ""}
										onChange={this.handleChange}
										name="nome"
										maxLength="40"
									/>
								</div>
								<div className="clientSingleField col2">
									<label>	<Translate value ="NomeComplementar" ></Translate></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.nome_2 || ""}
										onChange={this.handleChange}
										name="nome_2"
										maxLength="40"
									/>
								</div>
							</div>
							<div className="pendingRow">
								<div className="clientSingleField col2">
									<label><Translate value ="Morada" ></Translate> <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.morada || ""}
										onChange={this.handleChange}
										name="morada"
										maxLength="60"
									/>
								</div>
								<div className="clientSingleField col2">
									<label><Translate value ="MoradaComplementar" ></Translate> </label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.morada_2 || ""}
										onChange={this.handleChange}
										name="morada_2"
										maxLength="40"
									/>
								</div>
							</div>
							<div className="pendingRow">
								<div className="clientSingleField col2">
									<label><Translate value ="CodigoPostal" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.cd_post || ""}
										onChange={this.handleChange}
										name="cd_post"
										maxLength="10"
									/>
								</div>
								<div className="clientSingleField col2">
									<label><Translate value ="Localidade" ></Translate> <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.localidade || ""}
										onChange={this.handleChange}
										name="localidade"
										maxLength="40"
									/>
								</div>

							</div>
							<br></br>
							<font color="red">**(<Translate value ="ObrigatorioPeloMenosUm" ></Translate> ) </font>
							<div className="pendingRow">
								<div className="clientSingleField col3">
									<label><Translate value ="Telefone" ></Translate>  <font color="red">**</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.telefone || ""}
										onChange={this.handleChange}
										name="telefone"
										maxLength="30"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Telemovel" ></Translate>  <font color="red">**</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.telemovel || ""}
										onChange={this.handleChange}
										name="telemovel"
										maxLength="30"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Fax" ></Translate>  <font color="red">**</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.fax || ""}
										onChange={this.handleChange}
										name="fax"
										maxLength="30"
									/>
								</div>
							</div>
							<div className="pendingRow">
								<div className="clientSingleField col3">
									<label><Translate value ="Email" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.e_mail || ""}
										onChange={this.handleChange}
										name="e_mail"
										maxLength="241"
										
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Site" ></Translate> </label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.site || ""}
										onChange={this.handleChange}
										name="site"
										maxLength="132"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Observacoes" ></Translate> </label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.observacoes || ""}
										onChange={this.handleChange}
										name="observacoes"
										maxLength="50"
									/>
								</div>
							</div>
							<br></br>
							<h4 className="sectionTitle">
							<Translate value ="ContatoFinanceiros" ></Translate> 
							</h4>
							
							<div className="pendingRow">
							
								<div className="clientSingleField col3">
									<label><Translate value ="Nome" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={
											this.state.fin_nome_contato || ""
										}
										onChange={this.handleChange}
										name="fin_nome_contato"
										maxLength="40"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Telefone" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.fin_tel_contato || ""}
										onChange={this.handleChange}
										name="fin_tel_contato"
										maxLength="30"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="Email" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										value={
											this.state.fin_mail_contato || ""
										}
										className="form-control"
										onChange={this.handleChange}
										name="fin_mail_contato"
										maxLength="241"
									/>
								</div>
							</div>
							<div className="pendingRow">
								<div className="clientSingleField col1">
									<label><Translate value ="Horario" ></Translate>  <font color="red">*</font></label>
									<br />
									<input
										type="text"
										value={
											this.state.fin_horario_forn || ""
										}
										className="form-control"
										onChange={this.handleChange}
										name="fin_horario_forn"
										maxLength="132"
									/>
								</div>
							</div>
							<br></br>
							<h4 className="sectionTitle"><Translate value ="DadosFaturacao" ></Translate></h4>
							<div className="pendingRow">
								<div className="clientSingleField col3">
									<label><Translate value ="CodigoDeCertidaoPermanente" ></Translate> </label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.cod_cert_prm || ""}
										onChange={this.handleChange}
										name="cod_cert_prm"
										maxLength="20"
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="GrupoEconomico" ></Translate> </label>
									<br />
									<input
										type="text"
										className="form-control"
										value={this.state.grp_economico || ""}
										onChange={this.handleChange}
										name="grp_economico"
										maxLength="10"
									/>
								</div>
								<div className="clientSingleField col3">
								<div id="CaeRequired">
									<label><Translate value ="Cae" ></Translate> 

									</label>
                                      </div>
										
									
									<select
										 className="form-control"
										value={this.state.cae}
										
										onChange={this.handleChange}
										name="cae">
										<DropdownCAE />
									</select>
								</div>
							</div>
							<div className="pendingRow">
							<div className="clientSingleField col3">
									
									<div id="fatura">
									<label><Translate value ="EmailFaturaEletronica" ></Translate> 

									</label>
                                      </div>
									
									<input
										type="text"
										className="form-control"
										value={this.state.mail_contato || ""}
										onChange={this.handleChange}
										name="mail_contato"
										maxLength="241"
										disabled={this.state.migrationClient}
									/>
								</div>
								<div className="clientSingleField col3">
									<label><Translate value ="ComFaturacaoEletronica" ></Translate>  <font color="red">*</font></label>
									<br />
								
									<select
										 className="form-control"
										value={this.state.fat_ele}
										onChange={this.handleChange}
										name="fat_ele"
										disabled={this.state.migrationClient}>
									 <option></option>
									 <option value="X">{this.state.sim} </option> 
                                    <option value=" "> {this.state.nao} </option>
									</select>
								</div>
								<div className="clientSingleField col3">
									<label></label>
									<br />
									<input
										type="hidden"
										value={this.state.lojaVirtual || ""}
										name="lojaVirtual"
									/>
								</div>
							
							</div>
							<br></br>
							<div></div>
							
							<div className="pendingRow">
          <div className="clientSingleField col15">
		  <button
								onClick={this.sendData}
								className="mb-2 mr-2 btn btn-success">
								<Translate value ="Guardar" ></Translate> 
							</button>
							<Translate value ="UltimaAtualizacao" ></Translate>
							{" "} 
							<Translate value ={this.state.updateby}  ></Translate>
							 {" "}
							<Moment format="DD-MM-YYYY HH:mm[h]">
								{this.state.updateat}  
							</Moment> (d-m-y)  
							{" "}
							<Translate value = {this.state.mensagem} ></Translate>
							
							<br></br>
          </div>
          <div
            style={{ marginRight: "auto" }}
            className="clientSingleField col4"
          >
   
            <button
             
              style={{ float: "right" }}
              onClick={this.submitClient}
              className="mb-2 mr-2 btn btn-primary"
              disabled = {this.state.submitButton}
            >
           <Translate value ="Submeter" ></Translate> 
            </button>{" "}

            {this.state.path == "changeclientdata" && (
			<button
             
			 style={{ float: "right" }}
			 onClick={this.VerificarCancelar}
			 className="mb-2 mr-2 btn btn-danger"
			
		   >
		  <Translate value ="cancelarcliente" ></Translate> 
		   </button> ) }
            
          </div>
          
        </div>
						
						</div>
						
					</div></div>
				</React.Fragment>
			);
		}
	}
}

export default ExternalData;
